import Glide from "@glidejs/glide";
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

class SiteSlider {
  constructor() {
    if(document.querySelector("#glide1")) {
      var destopslide = new Glide("#glide1", {
        type: 'carousel',
        perView: 1,
        autoplay: 5000,
        transitionType: 'fade',
      })
      destopslide.mount()
    }

    if(document.querySelector("#glide2")) {
      var topmenudestop = new Glide("#glide2", {
        type: 'slider',
        startAt: 0,
        hoverpause: false,
        perView: 8
      })
      topmenudestop.mount()
    }

    if(document.querySelector("#glide3")) {
      var topmenumobile = new Glide("#glide3", {
        type: 'carousel',
        startAt: 0,
        autoplay: 3000,
        hoverpause: true,
        perView: 6,
        breakpoints: {
          700: {
            perView: 3
          }
        }
      })
      topmenumobile.mount()
    }

    if (document.querySelector("#glide4")) {
      var casino = new Glide("#glide4", {
        type: "carousel",
        autoplay: 3000,
        perView: 1,
      })
      casino.mount()
    }

    
    if (document.querySelector("#glide5")) {
      var casino = new Glide("#glide5", {
        type: "carousel",
        perView: 3,
        breakpoints: {
          800: {
            perView: 2
          },
          500: {
            perView: 1
          }
        }
      })
      casino.mount()
    }

    // if(document.querySelector("#partner-container")) {
    //   const swiper = new Swiper('#partner-container', {
    //     pagination: '.swiper-pagination',
    //     slidesPerView: 4,
    //     spaceBetween: 30,
    //     loop: true,
    //     autoplay: {
    //       delay: 2500,
    //       disableOnInteraction: false,
    //     }
    //     centeredSlides: true,
    //     paginationClickable: true,
    //     slideToClickedSlide: true
    //   });
    //   swiper.slideNext();
    // }
  }
}

export default SiteSlider